import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

export interface IFiDocumentEditItemSitemapDialogComponentData {
    item: any;
    selectedColumn: any;
    languageId: any;
    onClose$: Subject<void>;
    onMediaBankFileChanged$: Subject<any>;
    onContentChange$: Subject<any>;
}

@Component({
    selector: 'fi-document-edit-item-sitemap-dialog',
    template: `
        <fi-document-edit-item-sitemap
            [item]="data.item"
            [selectedColumn]="data.selectedColumn"
            [languageId]="data.languageId"
            (mediaBankFileChanged)="onMediaBankFileChanged($event)"
            (contentChange)="onContentChange($event)"
        />
    `,
    standalone: false,
})
export class FiDocumentEditItemSitemapDialogComponent extends FiDialogsContentBase<
    IFiDocumentEditItemSitemapDialogComponentData,
    undefined
> {
    onMediaBankFileChanged($event) {
        this.data.onMediaBankFileChanged$.next($event);
    }

    onContentChange($event) {
        this.data.onContentChange$.next($event);
    }
}
